import { COLORS, TYPOGRAPHY } from '@b2b/shared/consts';
import { ForwardRefRenderFunction, InputHTMLAttributes, ReactNode, forwardRef, useId } from 'react';
import styled from 'styled-components';

interface Props extends InputHTMLAttributes<HTMLInputElement> {
  text?: string | ReactNode;
  className?: string;
}

const Radio: ForwardRefRenderFunction<HTMLInputElement, Props> = ({ text, className, value, ...props }, ref) => {
  const ownId = useId();
  const id = props.id || ownId;

  return (
    <>
      <Input
        type="radio"
        value={value === undefined ? '' : value}
        {...props}
        ref={ref}
        id={id}
      />
      <Label
        className={className}
        htmlFor={id}
      >
        {text && <Text>{text}</Text>}
      </Label>
    </>
  );
};

export default forwardRef(Radio);

const Label = styled.label`
  position: relative;
  display: inline-flex;
  align-items: center;
  ${TYPOGRAPHY.body1Regular14}
  color: ${COLORS.grayscale700};
  cursor: pointer;

  &::before {
    content: '';
    min-width: 16px;
    min-height: 16px;
    border-radius: 50%;
    background-color: ${COLORS.white};
    border: 1px solid ${COLORS.grayscale200};
  }
`;

const Input = styled.input`
  position: absolute;
  left: 0;
  opacity: 0;

  &:checked + ${Label} {
    &::before {
      border-color: ${COLORS.primary300};
      border-width: 4px;
    }
  }
`;

const Text = styled.span`
  margin-left: 8px;
`;
